import type { RequestSequence } from '@/services/types/RequestSequence';

/**
 * Numbers the requests a screen starts, so that an answer can tell whether it is still the one
 * wanted. `begin()` marks a new request as the latest and returns the question to ask when its
 * answer lands: is this still the latest? Overlapping requests are answered in whatever order the
 * browser likes, and only the one asked for last may reach the screen.
 */
export function requestSequence(): RequestSequence {
  let latest = 0;
  return {
    begin() {
      latest += 1;
      const mine = latest;
      return () => mine === latest;
    },
  };
}
